import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Col, Row, Card, CardBody, CardTitle, Container, Table } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import ApexRadial from "../Dashboard/ApexRadial";
import { JobWidgetCharts } from "../DashboardJob/JobCharts";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {chartdata} from "../../common/data/demo/summary/chartsummary"
import { summaryData } from "common/data/demo/summary/summary";
import {monitoringdata} from "../../common/data/demo/monitoring/monitoring"
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid, ScatterChart, Scatter, ZAxis, BarChart, Bar } from 'recharts';


const MainDashboard = () => {
  const [vulnerabilitiesData, setVulnerabilitiesData] = useState([]);
  const [randomData, setRandomData] = useState(null);
  const [chartData, setChartData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [cardData, setCardData] = useState([]);
  const [artifactsData, setArtifactsData] = useState([]);


  

  const obj = JSON.parse(localStorage.getItem("authUser"));
  const userId = obj?.username;

  const scatterData = cardData.map(item => ({
    name: item.title,
    exploitability: item.stats.exploitabilityScore,
    impact: item.stats.impactScore,
    base: item.stats.baseScore,
    category: item.category,
    fixed: item.status?.fixed,
    severity: item.exploitscore
  }));

  const getQuadrantLabel = (impact, exploitability, base) => {
    if (base >= 9.0 || (impact >= 7.0 && exploitability >= 7.0)) {
      return "Critical Risk";
    }
    if (base >= 7.0 && base < 9.0 || (impact >= 7.0 && exploitability < 7.0)) {
      return "High Impact";
    }
    if (base >= 4.0 && base < 7.0 || (impact < 7.0 && exploitability >= 7.0)) {
      return "Easily Exploitable";
    }
    return "Lower Risk";
  };

  const COLORS = {
    Critical: '#DC3545', // danger red
    High: '#FD7E14',    // orange
    Medium: '#FFC107',  // warning yellow
    Low: '#17A2B8',     // info blue
    fixed: '#28A745',   // success green
    total: '#4F46E5'    // purple
  };

  const fetchData = async () => {
    try {
      setIsLoading(true);
      
      // Fetch vulnerabilities data
      const vulnerabilityResponse = await fetch(`https://api.compliance.cx/summary/data/${userId}`);
      const vulnerabilityData = await vulnerabilityResponse.json();
      
      if (vulnerabilityData && Object.keys(vulnerabilityData).length > 0) {
        setVulnerabilitiesData([
          { name: "Critical", value: vulnerabilityData.critical },
          { name: "High", value: vulnerabilityData.high },
          { name: "Medium", value: vulnerabilityData.medium },
          { name: "Low", value: vulnerabilityData.low },
        ]);
      };


      const artifactsResponse = await fetch(`https://api.compliance.cx/summary/artifacts/${userId}`);
      const artifactsData = await artifactsResponse.json();
      if (artifactsData && Object.keys(artifactsData).length > 0) {
        setArtifactsData(artifactsData);
      }

      // Fetch random data
      const randomDataResponse = await fetch(`https://api.compliance.cx/summary/random-data/${userId}`);
      const fetchedRandomData = await randomDataResponse.json();
      if (fetchedRandomData && Object.keys(fetchedRandomData).length > 0) {
        setRandomData(fetchedRandomData);
      }

      // Fetch chart data
      const chartDataResponse = await fetch(`https://api.compliance.cx/summary/chart-data/${userId}`);
      
      if (chartDataResponse.ok && chartDataResponse.headers.get("Content-Type").includes("application/json")) {
        const fetchedChartData = await chartDataResponse.json();
        
        if (fetchedChartData && fetchedChartData.length > 0) {
          const normalizedChartData = fetchedChartData.map(item => ({
            ...item,
            color: Array.isArray(item.color) ? JSON.stringify(item.color) : item.color
          }));
          setChartData(normalizedChartData);
        }
      }

      const response = await fetch(`https://api.compliance.cx/monitoring/${userId}`);
      const data = await response.json();
      setCardData(data);


    } catch (error) {
      if(userId==="demo"){
      setVulnerabilitiesData([
        { name: "Critical", value: 6},
        { name: "High", value: 33 },
        { name: "Medium", value: 28 },
        { name: "Low", value: 1},
      ]);
      const fetchedChartData = chartdata
      if (fetchedChartData && fetchedChartData.length > 0) {
        const normalizedChartData = fetchedChartData.map(item => ({
          ...item,
          color: Array.isArray(item.color) ? JSON.stringify(item.color) : item.color
        }));
        setChartData(normalizedChartData);
      };
      setRandomData(summaryData);
    
      const artifactsData = {"code":{"value":80},"containers":{"value":90},"compute":{"value":82},"services":{"value":88}}
      setArtifactsData(artifactsData);
      
      setCardData(monitoringdata);

    }
      

      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getChartOptions = (index) => {
    let options = {
      chart: { sparkline: { enabled: true } },
      dataLabels: { enabled: false },
      colors: ["#556ee6"],
      plotOptions: {
        radialBar: {
          hollow: { margin: 0, size: "60%" },
          track: { margin: 0 },
          dataLabels: { show: false },
        },
      },
    };

    const colorMap = {
      1: "#f46a6a",
      2: "#f46b4a",
      3: "#556ee6",
      4: "#34c38f"
    };

    options.colors[0] = colorMap[index] || options.colors[0];
    return options;
  };

  document.title = "Main Dashboard";

  const isDataMissing = !isLoading && (
    vulnerabilitiesData.length === 0 || 
    !randomData || 
    chartData.length === 0
  );

  const EmptyState = () => (
    <Card>
      <div className="text-center p-5">
        <div className="mb-4">
          <i className="mdi mdi-file-search text-primary" style={{ fontSize: "4rem" }} />
        </div>
        <h3 className="mb-3 font-weight-bold">No Insights Available Yet</h3>
        <p className="text-muted mb-4">
          It seems like no data is available at the moment. This could be due to recent activity or a delay in data updates.
          You can start by initiating scans or reviewing your recent actions.
        </p>
        <div className="d-flex justify-content-center gap-3">
          <Link to="/vulnerabilityscan" className="btn btn-primary px-4 py-2">
            Start a Vulnerability Scan
          </Link>
          <Link to="/malwareAnalysis" className="btn btn-warning px-4 py-2">
            Run Malware Analysis
          </Link>
          <Link to="/tm-create" className="btn btn-success px-4 py-2">
            Begin AI Threat Modeling
          </Link>
        </div>
      </div>
    </Card>
  );

  if (isLoading) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center p-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content" style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <Breadcrumbs breadcrumbItem="Home" />
        <Container fluid className="d-flex flex-column">
          {isDataMissing ? (
            <EmptyState />
          ) : (
            <>
              <Row className="d-flex align-items-stretch mb-0">
                <Container fluid className="py-4">
                  <Row className="g-4">
                    {chartData.map((item, key) => (
                      <Col lg={3} key={key}>
                        <Card className="mini-stats-wid mb-0">
                          <CardBody>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <p className="text-muted fw-medium">{item.title}</p>
                                <h4 className="mb-0">{item.price}</h4>
                              </div>
                              <div className="flex-shrink-0 align-self-center">
                                {Array.isArray(item.seriesData) && item.seriesData.length > 0 && (
                                  <JobWidgetCharts
                                    dataColors={item.color}
                                    series={item.seriesData}
                                    dir="ltr"
                                  />
                                )}
                              </div>
                            </div>
                          </CardBody>
                          <div className="card-body border-top py-3">
                            <p className="mb-0">
                              <span className={`badge badge-soft-${item.bagdeColor} me-2`}>
                                <i className={`bx ${item.istrendingArrow ? "bx-trending-down" : "bx-trending-up"} align-bottom me-1`} />
                                {item.perstangeValue}%
                              </span>
                              {item.istrendingArrow ? "Decrease" : "Increase"} last month
                            </p>
                          </div>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </Container>
              </Row>
<Row>
              <Card className="shadow-sm">
              <div style={{ height: "600px" }}>
  <ResponsiveContainer width="100%" height="100%">
    <ScatterChart
      margin={{ top: 20, right: 30, bottom: 40, left: 40 }}
    >
      {/* Background Quadrants */}
      <defs>
        <clipPath id="quadrantClip">
          <rect x="0" y="0" width="100%" height="100%" />
        </clipPath>
      </defs>

      {/* Quadrant Labels */}
      <text x="75%" y="25%" textAnchor="middle" fill="#666">
        Critical Risk
      </text>
      <text x="25%" y="25%" textAnchor="middle" fill="#666">
        Easily Exploitable
      </text>
      <text x="75%" y="75%" textAnchor="middle" fill="#666">
        High Impact
      </text>
      <text x="25%" y="75%" textAnchor="middle" fill="#666">
        Lower Risk
      </text>

      <CartesianGrid strokeDasharray="3 3" strokeWidth={0.5} />
      <XAxis
        type="number"
        dataKey="adjustedImpact"
        domain={[0, 10]}
        label={{
          value: "Adjusted Impact Score",
          position: "bottom",
        }}
        ticks={[0, 2, 4, 6, 8, 10]}
      />
      <YAxis
        type="number"
        dataKey="adjustedExploitability"
        domain={[0, 10]}
        label={{
          value: "Adjusted Exploitability Score",
          angle: -90,
          position: "left",
        }}
        ticks={[0, 2, 4, 6, 8, 10]}
      />

      {/* Quadrant Lines */}
      <line
        x1="50%"
        y1="0"
        x2="50%"
        y2="100%"
        stroke="#666"
        strokeDasharray="3 3"
      />
      <line
        x1="0"
        y1="50%"
        x2="100%"
        y2="50%"
        stroke="#666"
        strokeDasharray="3 3"
      />

      <Tooltip
        cursor={{ strokeDasharray: "3 3" }}
        content={({ payload }) => {
          if (payload && payload.length) {
            const data = payload[0].payload;
            return (
              <div className="bg-primary p-2 shadow-sm border">
                <p className="fw-bold mb-1">{data.name}</p>
                <p className="mb-1">Impact: {data.impact}</p>
                <p className="mb-1">
                  Exploitability: {data.exploitability}
                </p>
                <p className="mb-1">CVSS Score: {data.base}</p>
                <p className="mb-1">Severity: {data.severity}</p>
                <p className="mb-0">
                  Quadrant:{" "}
                  {getQuadrantLabel(
                    data.adjustedImpact,
                    data.adjustedExploitability,
                    data.base
                  )}
                </p>
              </div>
            );
          }
          return null;
        }}
      />

      <Legend verticalAlign="top" height={36} />
      {["Critical", "High", "Medium", "Low"].map((severity) => (
        <Scatter
          key={severity}
          name={severity}
          data={scatterData
            .filter((item) => item.severity === severity)
            .map((item) => ({
              ...item,
              adjustedImpact: 0.6 * item.impact + 0.4 * item.base,
              adjustedExploitability: 0.6 * item.exploitability + 0.4 * item.base,
            }))}
          fill={COLORS[severity]}
          shape="circle"
        />
      ))}
    </ScatterChart>
  </ResponsiveContainer>
</div>

              </Card>
            </Row>
              <Row>
                <Col xl="3">
                  {/* <Card>
                    <CardBody>
                      <div className="text-muted text-center">
                        <p className="mb-0">Exploitable</p>
                        <h5>x/10</h5>
                      </div>
                    </CardBody>
                  </Card> */}
                  
                  <Card>
                    <CardBody>
                      <div className="text-muted text-center">
                        <p className="mb-0">Vulnerabilities Overview</p>
                      </div>
                      <div className="table-responsive mt-4">
                        <Table className="table align-middle mb-0">
                          <tbody>
                            {vulnerabilitiesData.map((data, key) => (
                              <tr key={key}>
                                <td>
                                  <h4 className="font-size-14 mb-1">{data.name}</h4>
                                </td>
                                
                                <td>
                                  <h4 className="mb-0">{data.value}</h4>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                <Col lg={9} md={6} sm={12} className="mb-2" style={{ height: "100%" }}>
                  <Row>
                  {(artifactsData.code || artifactsData.containers || artifactsData.compute || artifactsData.services) && (
    <Card className="mb-3" style={{ height: "100%" }}>
      <CardBody style={{ position: "relative" }}>
        <CardTitle>
          <div style={{
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "flex-start",
            flexWrap: "nowrap",
          }}>
            {/* Conditionally render ApexRadial components based on the presence of data */}
            {artifactsData.code && artifactsData.code.value && (
              <ApexRadial
                dataColors='["--bs-success"]'
                label="Code"
                value={artifactsData.code.value}
              />
            )}
            {artifactsData.containers && artifactsData.containers.value && (
              <ApexRadial
                dataColors='["--bs-success"]'
                label="Containers"
                value={artifactsData.containers.value}
              />
            )}
            {artifactsData.compute && artifactsData.compute.value && (
              <ApexRadial
                dataColors='["--bs-success"]'
                label="Compute"
                value={artifactsData.compute.value}
              />
            )}
            {artifactsData.services && artifactsData.services.value && (
              <ApexRadial
                dataColors='["--bs-success"]'
                label="Services"
                value={artifactsData.services.value}
              />
            )}
          </div>
          <div style={{
            position: "absolute",
            bottom: "10px",
            right: "10px",
            fontSize: "12px",
            textAlign: "right",
            color: "rgb(169, 169, 169)",
          }}>
            ARTIFACTS
          </div>
        </CardTitle>
      </CardBody>
    </Card>
  )}

                    {randomData && (
                      <Card className="mb-4" style={{ height: "100%" }}>
                        <CardBody className="d-flex flex-column">
                          <CardTitle className="mb-4" style={{ textAlign: 'right' }}>
                            {randomData.title}
                          </CardTitle>
                          {randomData.description?.map((section, index) => (
                            <div key={index}>
                              <h5 className="mb-3">{section.heading}</h5>
                              <p>{section.paragraph}</p>
                            </div>
                          ))}
                          <p className="card-text">
                            <small className="text-muted">{randomData.timestamp}</small>
                          </p>
                        </CardBody>
                      </Card>
                    )}
                  </Row>
                </Col>
              </Row>
            </>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MainDashboard;